import { useState } from "react";
import { LicensesTab } from "../components/organisms/LicensesTab";
import { useListLicensesUrlQuery } from "../api/licenses/licenses.queries";
import { LoadingBlurDiv } from "@shared/components";
import { ClientSelector } from "../../clients";

export const LicensesPage = () => {
  const [selectedClient, setSelectedClient] = useState<string | null>(null);

  const { query, setFilters, resetFilters, currentFilters } =
    useListLicensesUrlQuery(selectedClient ?? "");

  return (
    <>
      <ClientSelector onSelect={setSelectedClient} />
      {selectedClient && (
        <LoadingBlurDiv isLoading={query.isFetching}>
          <LicensesTab
            tenantId={selectedClient}
            licenses={query.data?.data || []}
            paginatedMeta={query.data?.meta}
            isLoading={query.isFetching}
            onFilter={setFilters}
            onClearFilter={resetFilters}
            initialFilters={currentFilters}
          />
        </LoadingBlurDiv>
      )}
    </>
  );
};

export default LicensesPage;
